module.exports = __webpack_public_path__ + "img/case7.b594b935.jpg";